'use client';

import { type ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { Button } from '../ui/button';
import ArrivalTimeLinkLocal from '../ui/ArrivalTimeLinkLocal';
import { type Location } from '@/types/Location';

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export interface DriveOff {

    timeStamp: string
    location: Location
    timeSpent: number
    modelId: number
  };

export const columns: Array<ColumnDef<DriveOff>> = [
  {
    accessorKey: 'timeStamp',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => { column.toggleSorting(column.getIsSorted() === 'asc'); }}
        >
          TimeStamp
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const time = row.getValue('timeStamp');
      const location = row.getValue('location');

      return <ArrivalTimeLinkLocal utcTime={time} location={location}/>;
    },

  },
  {
    accessorKey: 'modelId',
    header: ({ column }) => (
      <Button
        variant="ghost"
        onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
      >
        Model ID
        <ArrowUpDown className="ml-2 h-4 w-4" />
      </Button>
    ),
    cell: ({ row }) => {
      return <div>{row.getValue('modelId') ?? 'N/A'}</div>;
    },
  },
  {
    accessorKey: 'location',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => { column.toggleSorting(column.getIsSorted() === 'asc'); }}
        >
          Location Name
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const location = row.getValue('location');

      return <div>{location.displayName}</div>;
    },
    filterFn: (row, columnId, filterValue) => {
      const locationName = row.original.location.displayName || '';
      return locationName.toLowerCase().includes(filterValue.toLowerCase());
    },
    sortingFn: (rowA, rowB, columnId) => {
      const locationNameA = rowA.original.location.displayName || '';
      const locationNameB = rowB.original.location.displayName || '';

      return locationNameA.localeCompare(locationNameB);
    },
  },
  {
    accessorKey: 'timeSpent',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => { column.toggleSorting(column.getIsSorted() === 'asc'); }}
        >
          Queue Time
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      // const location = row.getValue('location');
      return <div>{row.getValue('timeSpent')}</div>;
    }
  },
];
